import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "planning-tutorial-msg-1",
  "use": "planning-tutorial-msg-1-usage",
  "viewBox": "0 0 111 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 111 68\" id=\"planning-tutorial-msg-1\"><path fill=\"#C5C5C5\" d=\"M3.027.798 2.98.643 3.87.37l.043-.063 7.037 4.91-.573.82-5.96-4.16c13.84 42.913 49.093 64.356 105.88 64.356v1c-57.136 0-92.775-21.645-106.79-64.913L1.25 8.85l-.945-.326L2.98.782zm.78.655.61.425a83 83 0 0 1-.483-1.53L3.87.37l-.405.58.46.16-.118.345zm-.78-.655q.236.765.48 1.52l.3-.865-.466-.326.13-.177-.44-.156z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol